module.exports = "/_next/static/images/2ba628705869a75a562b5db43112896e-sanpablo-4-desktop.jpg";